import { apiClient } from './client';

export interface OrganizationSummary {
  id: string;
  name: string;
  code: string;
  type: string;
  is_active: boolean;
  subscription_tier: string;
  effective_tier: string | null;
}

export interface StartImpersonationRequest {
  org_id: string;
  reason: string; // server validates min 10 chars
}

export interface StopImpersonationRequest {
  org_id: string;
}

const BASE_URL = '/admin/impersonate';

export const adminImpersonateApi = {
  async start(data: StartImpersonationRequest): Promise<OrganizationSummary> {
    const response = await apiClient.post(`${BASE_URL}/start`, data);
    return response.data;
  },

  async stop(data: StopImpersonationRequest): Promise<{ status: string }> {
    const response = await apiClient.post(`${BASE_URL}/stop`, data);
    return response.data;
  },
};
